import { render, staticRenderFns } from "./CodeM.vue?vue&type=template&id=7b1c045d&scoped=true&"
import script from "./CodeM.vue?vue&type=script&lang=js&"
export * from "./CodeM.vue?vue&type=script&lang=js&"
import style0 from "./CodeM.vue?vue&type=style&index=0&id=7b1c045d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1c045d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b1c045d')) {
      api.createRecord('7b1c045d', component.options)
    } else {
      api.reload('7b1c045d', component.options)
    }
    module.hot.accept("./CodeM.vue?vue&type=template&id=7b1c045d&scoped=true&", function () {
      api.rerender('7b1c045d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/CodeM.vue"
export default component.exports